import { useEffect, useState } from 'react';
import { cargarSiteAssets } from '../config/siteAssets';

let cache = null;
let pendiente = null;
const suscriptores = new Set();

function suscribir(fn) {
  suscriptores.add(fn);
  return () => suscriptores.delete(fn);
}

function refrescar() {
  if (!pendiente) {
    pendiente = cargarSiteAssets()
      .then((mapa) => {
        cache = mapa;
        return mapa;
      })
      .catch(() => {
        // Si la tabla no existe todavia, el sitio sigue con sus fallbacks.
        cache = {};
        return {};
      })
      .finally(() => {
        pendiente = null;
      });
  }
  return pendiente;
}

/**
 * Devuelve el mapa { [clave]: { url, alt } } de site_assets.
 * Comparte la promesa entre todos los que lo piden, para no pegarle
 * varias veces a Supabase en el mismo montaje de la home.
 */
export function useSiteAssets() {
  const [assets, setAssets] = useState(cache || {});

  useEffect(() => {
    let activo = true;

    const recibir = (mapa) => {
      if (activo) setAssets(mapa);
    };

    suscribir(recibir);
    refrescar().then(recibir);

    return () => {
      activo = false;
      suscriptores.delete(recibir);
    };
  }, []);

  return assets;
}

export function getSiteAsset(assets, clave) {
  return assets?.[clave]?.url || null;
}

/**
 * Descarta el cache y vuelve a pedir los datos, notificando a todos los
 * componentes que ya estan montados. Asi un cambio hecho en el admin se ve
 * al instante en la home, sin recargar la pagina.
 */
export function invalidarSiteAssets() {
  cache = null;
  return refrescar().then((mapa) => {
    suscriptores.forEach((fn) => fn(mapa));
    return mapa;
  });
}
